import { ApiError } from '../errors/api-error.js';

function unwrapApiPayload(response) {
    if (response?.success === true && Object.prototype.hasOwnProperty.call(response, 'data')) {
        return response.data;
    }
    return response;
}

export class CustomerImportService {
    constructor(api) { this.api = api; }

    async _wrap(fn, fallback) {
        try { return unwrapApiPayload(await fn()); }
        catch (error) {
            if (error instanceof ApiError) throw error;
            throw ApiError.fromResponse(error, fallback);
        }
    }

    definitions() { return this._wrap(() => this.api.definitions(), 'Failed to load import definitions'); }
    detect(options) { return this._wrap(() => this.api.detect(options), 'Failed to detect import target'); }
    profiles(targetKey) { return this._wrap(() => this.api.profiles(targetKey), 'Failed to load import profiles'); }
    mappingSuggestions(targetKey, headers, profile) { return this._wrap(() => this.api.mappingSuggestions(targetKey, headers, profile), 'Failed to suggest mappings'); }
    createSession(options) { return this._wrap(() => this.api.createSession(options), 'Failed to stage import file'); }
    listSessions(params) { return this._wrap(() => this.api.listSessions(params), 'Failed to list import sessions'); }
    listRuns(params) { return this._wrap(() => this.api.listRuns(params), 'Failed to list import runs'); }
    getSession(id) { return this._wrap(() => this.api.getSession(id), 'Failed to load import session'); }
    getRun(id) { return this._wrap(() => this.api.getRun(id), 'Failed to load import run'); }
    analyze(id) { return this._wrap(() => this.api.analyze(id), 'Failed to start import analysis'); }
    updateMapping(id, mapping) { return this._wrap(() => this.api.updateMapping(id, mapping), 'Failed to update import mapping'); }
    rows(id, params) { return this._wrap(() => this.api.rows(id, params), 'Failed to load import rows'); }
    errors(id) { return this._wrap(() => this.api.errors(id), 'Failed to download import errors'); }
    manifest(id) { return this._wrap(() => this.api.manifest(id), 'Failed to prepare commit manifest'); }
    commit(id, manifest, key) { return this._wrap(() => this.api.commit(id, manifest, key), 'Failed to queue import commit'); }
    cancel(id) { return this._wrap(() => this.api.cancel(id), 'Failed to cancel import'); }
    retry(id, key) { return this._wrap(() => this.api.retry(id, key), 'Failed to retry import'); }
    compensate(id, key) { return this._wrap(() => this.api.compensate(id, key), 'Failed to queue compensation'); }
    reconcile(id) { return this._wrap(() => this.api.reconcile(id), 'Failed to reconcile import'); }
    saveProfile(profile) { return this._wrap(() => this.api.saveProfile(profile), 'Failed to save import profile'); }
    createPackage(sessionIds) { return this._wrap(() => this.api.createPackage(sessionIds), 'Failed to create import package'); }
    getPackage(id) { return this._wrap(() => this.api.getPackage(id), 'Failed to load import package'); }
    analyzePackage(id) { return this._wrap(() => this.api.analyzePackage(id), 'Failed to analyze import package'); }
    packageSuggestions(id) { return this._wrap(() => this.api.packageSuggestions(id), 'Failed to load relation suggestions'); }
    updatePackageRules(id, rules) { return this._wrap(() => this.api.updatePackageRules(id, rules), 'Failed to update relation rules'); }
    answerPackageQuestions(id, answers) { return this._wrap(() => this.api.answerPackageQuestions(id, answers), 'Failed to save import decisions'); }
    packageManifest(id) { return this._wrap(() => this.api.packageManifest(id), 'Failed to prepare package manifest'); }
    commitPackage(id, manifest, key) { return this._wrap(() => this.api.commitPackage(id, manifest, key), 'Failed to commit import package'); }
    cancelPackage(id) { return this._wrap(() => this.api.cancelPackage(id), 'Failed to cancel import package'); }
    getPackageRun(id) { return this._wrap(() => this.api.getPackageRun(id), 'Failed to load package run'); }
    compensatePackageRun(id, key) { return this._wrap(() => this.api.compensatePackageRun(id, key), 'Failed to compensate package run'); }
    reconcilePackageRun(id) { return this._wrap(() => this.api.reconcilePackageRun(id), 'Failed to reconcile package run'); }
}
